import { ButtonProps } from "./Button.types"
import "./Button.css"

const Button = (props: ButtonProps) => {
  const { 
    className,
    title,
    onClick,
    type,
    theme ,
    disabled = false,
    isLoading = false
  } = props

  return (
    <input
      style={isLoading ? {cursor: "wait", opacity: 0.4} : {}}
      className={`pi-button pi-button-type-${type}-${theme} ${className}`}
      type="button"
      value={title}
      onClick={onClick}
      disabled={disabled}
    />
  )
}

Button.defaultProps = {
  type: "full",
  theme: "dark"
}

export default Button
